
define('template!webshopFiltersEditView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (brandWarning) { ;
__p += '\n<div class="warning">' +
((__t = ( _.i18n('webshop.filters.brandWarning', null, 'The product pages find the brand logo through the English name "Brand": keep it.') )) == null ? '' : __t) +
'</div>\n';
 } ;
__p += '\n<div class="names">\n    <div class="libelle">' +
((__t = ( _.i18n('common.name', null, 'Name') )) == null ? '' : __t) +
'</div>\n    ';
 _.each(languages, function (l) { ;
__p += '\n    <div class="name-row">\n        <span class="lang">' +
((__t = ( l.lang )) == null ? '' : __t) +
'</span>\n        <input type="text" class="name" data-lang="' +
((__t = ( l.lang )) == null ? '' : __t) +
'" value="' +
__e( l.name ) +
'"/>\n    </div>\n    ';
 }); ;
__p += '\n    <div class="hint">' +
((__t = ( _.i18n('webshop.filters.nameHint', null, 'An empty language falls back to English on the webshop.') )) == null ? '' : __t) +
'</div>\n</div>\n<div class="item">\n    <div class="libelle">' +
((__t = ( _.i18n('common.code', null, 'Code') )) == null ? '' : __t) +
'</div>\n    <input type="text" class="code" value="' +
__e( code ) +
'"/>\n    ';
 if (kind === 'filter') { ;
__p += '\n    <div class="hint">' +
((__t = ( _.i18n('webshop.filters.codeHint', null, '"Print technique" shows the values as print techniques on the product page.') )) == null ? '' : __t) +
'</div>\n    ';
 } ;
__p += '\n</div>\n';
 if (kind === 'filter') { ;
__p += '\n<div class="item">\n    <div class="libelle">' +
((__t = ( _.i18n('webshop.filters.group', null, 'Group') )) == null ? '' : __t) +
'</div>\n    <select class="group">\n        ';
 if (!_.findWhere(groups, {id: 'webshop'})) { ;
__p += '\n        <option value="webshop" ';
 if (groupId === 'webshop') { ;
__p += 'selected';
 } ;
__p += '>Webshop</option>\n        ';
 } ;
__p += '\n        ';
 _.each(groups, function (g) { ;
__p += '\n        <option value="' +
__e( g.id ) +
'" ';
 if (groupId === g.id) { ;
__p += 'selected';
 } ;
__p += '>' +
__e( g.label ) +
'</option>\n        ';
 }); ;
__p += '\n    </select>\n</div>\n';
 } else { ;
__p += '\n<div class="item color-item">\n    <div class="libelle">' +
((__t = ( _.i18n('common.color', null, 'Colour') )) == null ? '' : __t) +
'</div>\n    <label>\n        <input type="checkbox" class="has-color" ';
 if (hasColor) { ;
__p += 'checked';
 } ;
__p += '/>\n        ' +
((__t = ( _.i18n('webshop.filters.colorSwatch', null, 'Show as colour swatch') )) == null ? '' : __t) +
'\n    </label>\n    <input type="color" class="color" value="' +
((__t = ( color )) == null ? '' : __t) +
'" ';
 if (!hasColor) { ;
__p += 'disabled';
 } ;
__p += '/>\n</div>\n<div class="item">\n    <div class="libelle">' +
((__t = ( _.i18n('webshop.filters.param', null, 'Parameter (brand logo file)') )) == null ? '' : __t) +
'</div>\n    <input type="text" class="param" value="' +
__e( param ) +
'"/>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

